export const isSubProject = (projectKey) => {
  let projectKeyArray = projectKey.split('/');
  projectKeyArray.shift();
  return projectKeyArray.length > 2;
};
